import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import LogoImageVNLWhite from '../../assets/images/VNL_logo_white.svg';

import './style.scss';

const FooterMinimal = () => {
  const { t } = useTranslation();

  return (
    <footer className="FooterMinimal">
      <Container className="FooterMinimal-container">
        <div className="FooterMinimal__wrapper">
          <div>
            <CoreLink href="/algemene-voorwaarden-risicomonitor" className="FooterMinimal__link">
              {t('general.terms')}
            </CoreLink>

            <CoreLink href="/privacy-verklaring" className="FooterMinimal__link">
              {t('general.privacy')}
            </CoreLink>
          </div>
          <CoreLink className="Logo" href="/">
            <img src={LogoImageVNLWhite} alt="VeiligheidNL" />
          </CoreLink>
        </div>
      </Container>
    </footer>
  );
};

export default FooterMinimal;
